import React from 'react'
import {useTranslation} from 'react-i18next'

import QRCode from './components/QRCode'
import QRCard from './components/QRCard'
import Card from 'features/common/components/Card'
import QRSticker from './components/QRSticker'
import QRTabletop from './components/QRTabletop'

const QRPage = () => {
    const {t} = useTranslation()
    return (
        <div className="flex flex-1 flex-col gap-6 overflow-auto">
            <Card className="flex flex-1 items-center justify-center bg-white">
                <div className="flex flex-1 flex-col gap-6">
                    <div className="text-[1.75rem] font-medium">
                        {t('QR_TITLE')}
                    </div>
                    <div className="flex flex-1 flex-col items-center gap-20">
                        <QRCode />
                    </div>
                </div>
            </Card>

            <Card className="flex flex-1 bg-white">
                <div className="flex flex-1 flex-col gap-6">
                    <div className="text-[1.75rem] font-medium">
                        {t('QR_POSM')}
                    </div>
                    <div className="flex flex-1 flex-col items-stretch justify-around gap-6">
                        <QRSticker />
                        <div className="h-px w-full bg-grey-40 px-12" />
                        <QRCard />
                        <div className="h-px w-full bg-grey-40 px-12" />
                        <QRTabletop />
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default QRPage
